import { render } from "./PriceTrackModule.vue?vue&type=template&id=ed1a9e08&ts=true"
import script from "./PriceTrackModule.vue?vue&type=script&lang=ts"
export * from "./PriceTrackModule.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__